export const LOCAL_STORAGE_FEATURE_FLAGS_KEY = 'featureFlagsAtom';

export enum ExacareFeature {
  CRM_ADMIN_HUB = 'VITE_FEATURE_FLAG_CRM_ADMIN_HUB',
  VACCINES = 'VITE_FEATURE_FLAG_VACCINES',
  OOC_PHASE_2 = 'VITE_FEATURE_FLAG_OOC_PHASE_2',
  CRM_ACTIVITY_LOG = 'VITE_FEATURE_FLAG_CRM_ACTIVITY_LOG',
  ARCHIVED_RESIDENTS = 'VITE_FEATURE_FLAG_ARCHIVED_RESIDENTS',
  MEDICATION_TASK_REGIMENS = 'VITE_FEATURE_FLAG_MEDICATION_TASK_REGIMENS',
  CRM_RESIDENT_CALLS = 'VITE_FEATURE_FLAG_CRM_RESIDENT_CALLS',
  CRM_RESIDENT_TEXTS = 'VITE_FEATURE_FLAG_CRM_RESIDENT_TEXTS',
  VITE_FEATURE_FLAG_INCIDENTS_V2 = 'VITE_FEATURE_FLAG_INCIDENTS_V2',
  DATA_CENTER_TAB = 'VITE_FEATURE_FLAG_DATA_CENTER_TAB',
  SLIDING_SCALE_DOSE = 'VITE_FEATURE_FLAG_SLIDING_SCALE_DOSE',
  INCIDENT_NOTIFICATIONS = 'VITE_FEATURE_FLAG_INCIDENT_NOTIFICATIONS',
  NEW_VITALS_API = 'VITE_FEATURE_FLAG_NEW_VITALS_API',
  SEND_PAYMENT_LINKS = 'VITE_FEATURE_FLAG_SEND_PAYMENT_LINKS',
  TASKS_PAGE_V2 = 'VITE_FEATURE_FLAG_TASKS_PAGE_V2',
  INTERCOM = 'VITE_FEATURE_FLAG_INTERCOM',
  EHR_MEDICATIONS_PATTERNED_RECURRENCE = 'VITE_FEATURE_FLAG_EHR_MEDICATIONS_PATTERNED_RECURRENCE',
  VITE_FEATURE_FLAG_USER_LANDING_PREFERENCES = 'VITE_FEATURE_FLAG_USER_LANDING_PREFERENCES',
  EHR_TASK_EXTENSIONS = 'VITE_FEATURE_FLAG_EHR_TASK_EXTENSIONS',
  CRM_SCREENER = 'VITE_FEATURE_FLAG_CRM_SCREENER',
  CRM_SCREENER_REPORT = 'VITE_FEATURE_FLAG_CRM_SCREENER_REPORT',
  CRM_TASK_REMINDERS = 'VITE_FEATURE_FLAG_CRM_TASK_REMINDERS',
  CRM_SCREENER_LEAD_COMMENTS = 'VITE_FEATURE_FLAG_CRM_SCREENER_LEAD_COMMENTS',
  CRM_SCREENER_PCC_ADVANCED_INTEGRATION = 'VITE_FEATURE_FLAG_CRM_SCREENER_PCC_ADVANCED_INTEGRATION',
  CRM_SCREENER_RULE_AI_SUGGESTIONS = 'VITE_FEATURE_FLAG_CRM_SCREENER_RULE_AI_SUGGESTIONS',
  CRM_SCREENER_MEDICARE = 'VITE_FEATURE_FLAG_CRM_SCREENER_MEDICARE',
  CRM_SCREENER_LEAD_S_OFFENDER_CHECK = 'VITE_FEATURE_FLAG_CRM_SCREENER_LEAD_S_OFFENDER_CHECK',
  CRM_SCREENER_BIDIRECTIONAL_ACTIONS = 'VITE_FEATURE_FLAG_CRM_SCREENER_BIDIRECTIONAL_ACTIONS',
  CRM_SCREENER_MEDICARE_P2 = 'VITE_FEATURE_FLAG_CRM_SCREENER_MEDICARE_P2',
  CRM_SCREENER_BIDIRECTIONAL_HOSPITAL_CHAT = 'VITE_FEATURE_FLAG_CRM_SCREENER_BIDIRECTIONAL_HOSPITAL_CHAT',
  CRM_SCREENER_MANAGED_MEDICARE = 'VITE_FEATURE_FLAG_CRM_SCREENER_MANAGED_MEDICARE',
  CRM_SCREENER_INTAKE_EXTENDED_CARE = 'VITE_FEATURE_FLAG_CRM_SCREENER_INTAKE_EXTENDED_CARE',
  CRM_SCREENER_TASKS = 'VITE_FEATURE_FLAG_CRM_SCREENER_TASKS',
  DAILY_SCHEDULED_MOVE_IN_OUT_REMINDERS = 'VITE_FEATURE_FLAG_DAILY_SCHEDULED_MOVE_IN_OUT_REMINDERS',
  INSURANCE_ELIGIBILITY = 'VITE_FEATURE_FLAG_INSURANCE_ELIGIBILITY',
  CRM_PHONE_AGENT = 'VITE_FEATURE_FLAG_CRM_PHONE_AGENT',
  SCREENER_ADMISSION_FLAGS = 'VITE_FEATURE_FLAG_SCREENER_ADMISSION_FLAGS',
  CRM_SCREENER_LEAD_WAITLIST = 'VITE_FEATURE_FLAG_CRM_SCREENER_LEAD_WAITLIST',
  CRM_SCREENER_BED_HOLD = 'VITE_FEATURE_FLAG_CRM_SCREENER_BED_HOLD',
  CRM_SCREENER_RESIDENTS_POINT_CLICK_CARE_UPDATES = 'VITE_FEATURE_FLAG_CRM_SCREENER_RESIDENTS_POINT_CLICK_CARE_UPDATES',
  DATA_CENTER_OMNI_REPORT_BUILDER = 'VITE_FEATURE_FLAG_DATA_CENTER_OMNI_REPORT_BUILDER',
  OPINIONATED_MEDICARE_INSURANCE_UI = 'VITE_FEATURE_FLAG_OPINIONATED_MEDICARE_INSURANCE_UI',
  CRM_SCREENER_PAYER_LIST = 'VITE_FEATURE_FLAG_CRM_SCREENER_PAYER_LIST',
  CRM_SCREENER_PCC_SUMMARY = 'VITE_FEATURE_FLAG_CRM_SCREENER_PCC_SUMMARY',
  CRM_SCREENER_ORGANIZATION_STATES = 'VITE_FEATURE_FLAG_CRM_SCREENER_ORGANIZATION_STATES',
  CRM_SCREENER_NEW_HOSPITAL_MESSAGE_NOTIFICATIONS = 'VITE_FEATURE_FLAG_CRM_SCREENER_NEW_HOSPITAL_MESSAGE_NOTIFICATIONS',
  CRM_SCREENER_PAL_PRE_AUTH = 'VITE_FEATURE_FLAG_CRM_SCREENER_PAL_PRE_AUTH',
  CRM_SCREENER_PAL_PRE_AUTH_AUTHORIZATIONS_TABLE = 'VITE_FEATURE_FLAG_CRM_SCREENER_PAL_PRE_AUTH_AUTHORIZATIONS_TABLE',
  CRM_SCREENER_OVERRIDE_AI_ANALYSIS_RESULT = 'VITE_FEATURE_FLAG_CRM_SCREENER_OVERRIDE_AI_ANALYSIS_RESULT',
  CRM_SCREENER_UNIFIED_INSURANCE_TAB = 'VITE_FEATURE_FLAG_CRM_SCREENER_UNIFIED_INSURANCE_TAB',
  CRM_SCREENER_TRACKED_MEDS_RULES = 'VITE_FEATURE_FLAG_CRM_SCREENER_TRACKED_MEDS_RULES',
  PYLON = 'VITE_FEATURE_FLAG_PYLON',
  SCREENER_RULES_RED_YELLOW_RENAME = 'VITE_FEATURE_FLAG_SCREENER_RULES_RED_YELLOW_RENAME',
  CRM_TASK_NOTIFICATIONS = 'VITE_FEATURE_FLAG_CRM_TASK_NOTIFICATIONS',
  ENABLE_NEW_CRM_SCREENER_COMBINE_LEADS = 'VITE_FEATURE_FLAG_ENABLE_NEW_CRM_SCREENER_COMBINE_LEADS',
  CRM_SCREENER_BATCH_DOCUMENT_STATS = 'VITE_FEATURE_FLAG_CRM_SCREENER_BATCH_DOCUMENT_STATS',
  CRM_SCREENER_HCHB = 'VITE_FEATURE_FLAG_CRM_SCREENER_HCHB',
  CRM_SCREENER_ADMISSION_STATUS_SYNC = 'VITE_FEATURE_FLAG_CRM_SCREENER_ADMISSION_STATUS_SYNC',
  CRM_REFERRAL_OUTBOUND = 'VITE_FEATURE_FLAG_CRM_REFERRAL_OUTBOUND',
  CRM_ESIGN = 'VITE_FEATURE_FLAG_CRM_ESIGN'
}

export class FeatureFlagService {
  public static isEnabled(featureName: ExacareFeature): boolean {
    const overriddenFeatureFlag = this.getOverriddenValue(featureName);
    if (overriddenFeatureFlag === true || overriddenFeatureFlag === false) {
      return overriddenFeatureFlag;
    }
    return import.meta.env[featureName] === 'true';
  }

  /**
   *
   * @param featureName The feature flag to check if overridden
   * @returns boolean if the feature flag is overridden as either true|false
   * @returns null if the feature flag is not overridden
   */
  private static getOverriddenValue(
    featureName: ExacareFeature
  ): boolean | null {
    const featureFlags = localStorage.getItem(LOCAL_STORAGE_FEATURE_FLAGS_KEY);

    if (!featureFlags) {
      return null;
    }

    try {
      const parsedFeatureFlags = JSON.parse(featureFlags) as Record<
        string,
        boolean
      >;
      if (
        parsedFeatureFlags[featureName] === true ||
        parsedFeatureFlags[featureName] === false
      ) {
        return parsedFeatureFlags[featureName];
      }
      return null;
    } catch (_error) {
      return null;
    }
  }
}
